import { WppIconSuccess, WppIconWarning } from '@wppopen/components-library-react'
import { ERROR_MESSAGES } from 'utils/constants'

export const mainRequiredFields = ['reference_name', 'variant_id']
export const attributesFields = [
  'quantity',
  'size',
  'colour',
  'flavour',
  'format',
  'formulation',
  'product_dimensions',
  'pack_count',
  'model_number',
]

export const renderVariantAttributesMessage = (
  isFormActive: Boolean,
  inputValue: string | undefined,
  errorMessage: string | undefined,
  isOneAttributeFilled: boolean,
) => {
  if (!isFormActive || isOneAttributeFilled) return undefined
  if (errorMessage) return errorMessage
  if (!inputValue) return ERROR_MESSAGES.MANDATORY_FIELD
}

export const renderVariantAttributesMessageType = (
  isFormActive: boolean,
  inputValue: string | undefined,
  errorMessage: string | undefined,
  isOneAttributeFilled: boolean,
) => {
  if (!isFormActive || isOneAttributeFilled) return undefined
  if (errorMessage) return 'error'
  if (!inputValue) return 'warning'
}

export const renderVariantAttributesIcon = (
  value: string | '' | undefined,
  errorMessage: string | undefined,
  isOneAttributeFilled: boolean,
) => {
  if (!!errorMessage) return undefined
  if (!!value) return <WppIconSuccess slot="icon-end" aria-label="Success icon" />
  if (!isOneAttributeFilled) return <WppIconWarning slot="icon-end" aria-label="Warning icon" />
}
